/* global fbq, _tfa */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import {
    Play, Pause, CircleNotch,
} from '@phosphor-icons/react';
// import { faPlayCircle, faPauseCircle } from '@fortawesome/free-regular-svg-icons';
import exact from 'prop-types-exact';
import A1GA from '../../../helpers/A1GA';
import AudioEngine from '../../../helpers/AudioEngine';
// import Button from '../../../common/button/Button';
import { dismissAlert, showError } from '../../../common/A1Alert/A1Alert';

const HEARTBEAT_LOGGING_INTERVAL = 1000 * 60 * 4; // 4 minutes // @TODO see if this is still necessary (as there are now the extra isListening events, see below and https://trello.com/c/uWoT1ZoH/1809-investigate-average-session-time-on-the-page )
// delay in minutes between the logs -> 1, 5, 15, 30, (since 31.05.2022 also 60, 90, 120), since  14.06.2022 also (150, 180, 210, 240, 270, 300, 330, 360, 390, 420, 450, 480. 510, 540) minutes
const ISLISTENING_LOGGING_INTERVALS = [1, 4, 10, 15, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30];
const IMG_MEDIA_URL = 'https://a1media.antena1.com.br/image/album/150x150/';
const DEFAULT_ALBUM = `${IMG_MEDIA_URL}defaultAlbum.jpg`;
const isProduction = process.env.NODE_ENV === 'production';

// This is an active/passive component.
// It has active functions that set flags in the reducer
// and based on those flags other (passive) functions control the player
// Also, some events from the player invoke functions that update the reducer
// I am not sure if this is a good way of doing it :/

class MediaPlayerComponent extends Component {
    constructor(props) {
        super(props);

        this.enableLogs = false; // Set this to true to see additional audio engine and buffer logs

        this.numErrors = 0;

        this.isListeningLoggingCounter = false;

        this.isListeningLoggingHandle = false;

        this.heartBeatHandle = false;

        this.errorRetryHandle = false; // handle of the setTimeout scheduled in _onError to retry loading the stream

        this.suppressNextPauseEvent = false; // AudioEngine.load() fires a native 'pause' event as a side-effect; ignore it when we triggered the load() ourselves

        this.stalledAlertId = null;

        this._play = this._play.bind(this);

        this._pause = this._pause.bind(this);

        this._onPause = this._onPause.bind(this);
    }

    componentDidMount() {
        window.addEventListener('a1-consent-change', this._initAds);
        AudioEngine.enableDebugging(this.enableLogs);

        AudioEngine.setInitListener(() => {
            AudioEngine.addEventListener(AudioEngine.canPlayEvent, this.props.onCanPlay); // Note: The onCanPlay is not used currently

            if (this.enableLogs) {
                this._logBuffer();
            }
        });

        AudioEngine.addEventListener('error', this._onError);

        AudioEngine.addEventListener('playing', this._onPlaying);

        AudioEngine.addEventListener('stalled', this._onStalled);

        AudioEngine.addEventListener('pause', this._onPause);

        AudioEngine.addEventListener('ended', this._onEnded);

        AudioEngine.addEventListener('waiting', this._onWaiting);

        // Check _initAds for Ad specific event listeners

        // other possible media events
        // AudioEngine.addEventListener('play', this.props.onPlay);
        // AudioEngine.addEventListener('canplay', this.props.onCanPlay);
        // AudioEngine.addEventListener('loadedmetadata', function(){console.log("onLoadedMetaData...")}); //this might come in handy one day (currently we do the meta stuff on the api...)
        // AudioEngine.addEventListener('suspend', function(){console.log("suspend...")}); //this might come in handy one day (currently we do the meta stuff on the api...)

        // Pass the adTagUrls to the AudioEngine
        // This is done before calling _initAds, to know if any adTagUrls are available at all
        // and for the case the user clicks play before the profile was loaded
        AudioEngine.setAdTagUrls(this.props.prerollAdTagUrls);

        // This is a custom event that fires while the ad stuff is being loaded
        // It also must be setup as soon as possible for the case the user clicks play before the profile was loaded
        AudioEngine.addAdStuffLoadingEventListener(this._onWaiting);

        if (this.props.jwt === null) {
            // Init the ads
            // Otherwise wait for the request for the user object to return
            // This way we do not need to load ad stuff for PRO users
            // If there is no jwt, the user cannot be PRO.
            // If the user logs in in a later moment, we will deactivate the ads then
            this._initAds();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.volume !== this.props.volume) {
            this._setVolume(this.props.volume);
        }

        // prevProps.shouldBePlaying on purpose: the new value would make _changeSource/_changeStream also call play(), duplicating the _togglePlay call below.
        if (prevProps.currentSources !== this.props.currentSources) {
            this._changeSource(this.props.currentSources, prevProps.shouldBePlaying);
        }

        if (prevProps.currentStreamId !== this.props.currentStreamId) {
            this._changeStream(prevProps.shouldBePlaying);
        }

        if (prevProps.isPro !== this.props.isPro) {
            // Once the user object was loaded, isPro will be set to either true or false (default is null)
            // Check if we need to initialize the ad stuff
            // Note: This increases the time for the player to be ready as we have to wait until the user object was returned
            // But this way we only load ads for users that will actually hear one

            // Note: There is at least one edge case that is not properly handled at the moment:
            // When the user logs off, we do not reset the userIdOrBrowserHash parameter. But this should rarely happen and not cause any harm
            if (!this.props.isPro) {
                this._initAds();
            } else {
                AudioEngine.setIsPro(this.props.isPro);
            }
        }

        if (prevProps.shouldBePlaying !== this.props.shouldBePlaying && this.props.playerStatus !== 'loading') {
            this._togglePlay(this.props.shouldBePlaying);
        }

        if ((this.props.isLive === 'otherMedia' && prevProps.currentSources !== this.props.currentSources) ||
            (this.props.isLive !== 'otherMedia' && prevProps.currentStream !== this.props.currentStream) ||
            (prevProps.isLive !== this.props.isLive)) {
            // This is really ugly because of the weird way that this component handles everything :(
            // @TODO this really needs some refactoring...

            // Note: This only logs changes once the aovivoBar was unlocked. This is due to the way this component works and to avoid logging of the stream restore from local storage
            // Note: This currently also logs a track in a playlist finished and the next was started automatically.
            // It is thus not always a user started interaction event.
            // Hope this causes no problems...

            if (this.props.isLive === 'otherMedia' && prevProps.currentSources[0]?.src === this.props.currentSources[0]?.src) {
                // this check is necessary because the otherMedia sources are not immutable and thus trigger a 'source change' even when the same track was paused and played again
                return;
            }

            if (this.props.locked) {
                // this is to avoid logging stream changes because of the restore of the stream from the local storage
                return;
            }

            if (prevProps.locked) {
                // this is to avoid logging the first play event after restoring currentStream from the local storage
                return;
            }

            const prevStreamName = prevProps.isLive === 'otherMedia' ?
                `${prevProps.nowPlayingMusic.artist} - ${prevProps.nowPlayingMusic.song}` :
                prevProps.currentStream.streamName;

            const currentStreamName = this.props.isLive === 'otherMedia' ?
                `${this.props.nowPlayingMusic.artist} - ${this.props.nowPlayingMusic.song}` :
                this.props.currentStream.streamName;

            const extraLabel = `${prevStreamName} -> ${currentStreamName}`;

            // log to GA
            this._logToGA('sourceChanged', extraLabel, false, true);
        }

        if (prevProps.currentIndex !== this.props.currentIndex || prevProps.trackList !== this.props.trackList) {
            // @TODO this is kinda strange.
            // We depend on the change of the index to start the next track.
            // This could/should also be done, when setting the next index...
            // need to think again about this
            const currentIndex = this.props.currentIndex;

            if (currentIndex < this.props.trackList.length) {
                const src = this.props.trackList[currentIndex].musicTrack; // for testing "https://freesound.org/data/previews/33/33245_65091-lq.mp3"
                const cover = this.props.trackList[currentIndex].albumCover;

                this.props.playMediaFromSourceWithMeta(src, {
                    album: this.props.trackList[currentIndex].albumName,
                    artist: this.props.trackList[currentIndex].artistName,
                    artistSlug: this.props.trackList[currentIndex].artistSlug,
                    cover: cover ? IMG_MEDIA_URL + cover : DEFAULT_ALBUM,
                    itunes: this.props.trackList[currentIndex].iTunesLink,
                    song: this.props.trackList[currentIndex].musicName,
                    musicSlug: this.props.trackList[currentIndex].musicSlug,
                });
            }
        }

        if (this.props.isLive === 'otherMedia' && prevProps.playerStatus !== this.props.playerStatus && (this.props.playerStatus === 'ended' || this.props.playerStatus === 'error')) {
            // the player status changed to either ended or error

            // check if there are more musics in the playlist, if not, abort
            if (this.props.trackList.length === 0 || this.props.currentIndex === this.props.trackList.length - 1) {
                return;
            }

            // there are more musics, set the current track to be the next one
            const nextIndex = this.props.currentIndex + 1;

            setTimeout(() => {
                // this short delay is necessary if the previous track errored to no cause the next rack to be paused right after being started. (check _onError() function)
                // @TODO one day remove the timeout and find a rpoper solution
                this.props.setCurrentTrack(nextIndex, this.props.trackList[nextIndex].musicId);
            }, 300);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('a1-consent-change', this._initAds);
    }

    debug = (...args) => {
        // eslint-disable-next-line no-param-reassign
        args[0] = `[MediaPlayer] ${args[0]}`;

        // eslint-disable-next-line no-console
        this.enableLogs && console.log(...args);
    };

    /* HELPER FUNCTIONS */

    _initAds = () => {
        // If set, use the userId, otherwise the browserHash
        // If no jwt is present on DidMount, we use the browserHash, otherwise the userId via didUpdate
        // Note: TargetSpot asked to make the userId 'longer'. We could use the idHash from the participante table, but I would rather not send it to the client.
        // So we (Samuel from TargetSpot and I) came up with the following "solution" :D
        AudioEngine.setUserIdOrBrowserHash(this.props.userId ? `SomeExtraCharactersForTargetSpot-${this.props.userId}` : this.props.browserHash);

        AudioEngine.setIsPro(this.props.isPro); // Setting it here for the case when a PRO user logs off

        AudioEngine.addAdEventListener('contentPauseRequested', this._onContentPauseRequested); // This fires as soon as an ad should start, but it might first load

        AudioEngine.addAdEventListener('contentResumeRequested', this._onContentResumeRequested); // This fires as soon as an ad finshed and the player should restart

        AudioEngine.addAdEventListener('start', this._onPlaying);

        AudioEngine.addAdEventListener('resume', this._onPlaying);

        AudioEngine.addAdEventListener('adBuffering', this._onWaiting); // Never saw this fire until now, so it is untested as of now...

        AudioEngine.initAds(); // First set up all the listener and other things, then call initAds

        return true;
    }

    _logToGA = (action, extraLabel, nonInteraction, useOnlyExtraLabel) => {
        // if useOnlyExtraLabel is not true the label will be either the current streamName or the artist and song of the otherMedia that is playing
        // the category is always either Aovivo or otherMedia
        const isLive = this.props.isLive !== 'otherMedia';
        const streamName = isLive ? this.props.currentStream.streamName : `${this.props.nowPlayingMusic.artist} - ${this.props.nowPlayingMusic.song}`;
        const category = isLive ? 'Aovivo' : 'otherMedia'; // changed the otherMedia category from Aovivo-otherMedia to otherMedia as it didn't make too much sense
        const label = useOnlyExtraLabel ? extraLabel :
            `${streamName}${extraLabel ? ` - ${extraLabel}` : ''}`;

        A1GA.event({
            category,
            action,
            label,
            nonInteraction, // these won't show up in the active users realtime count, but they will increase avarage time on page and can be seen in 'events (last 30 minutes)
        });
    }

    /* PASSIVE FUNCTIONS */

    _onError = (e) => {
        // only saw this function fire when there is no internet (on player start) for now
        // so, try to reconnect the player for 3 times
        // after that show a warning that there might be a problem with the internet connection

        // log to GA
        this._logToGA('playerError', false, true); // Couldn't get more information from the event, so no extraLabel

        // eslint-disable-next-line no-console
        console.warn('player error', e);

        if (this.numErrors < 3) {
            this.numErrors += 1;

            if (this.props.shouldBePlaying) {
                // if the player should be playing, try to reload
                // Note: clear any previously scheduled retry first, so a stale retry can never fire after this one and race it (this used to leave the player stuck in the 'loading' state forever)
                clearTimeout(this.errorRetryHandle);

                this.errorRetryHandle = setTimeout(() => {
                    this.suppressNextPauseEvent = true;

                    AudioEngine.load();

                    AudioEngine.play();
                }, 1000);
            }
        } else {
            // log to GA
            this._logToGA('playerError', `Stopped reloading. shouldBePlaying: ${this.props.shouldBePlaying}`, true);

            if (this.stalledAlertId) {
                // dismiss the stalled alert if there is one
                dismissAlert(this.stalledAlertId);

                this.stalledAlertId = null;
            }

            if (this.props.shouldBePlaying) {
                // if the player should be playing, show a message. (due to the unlock stuff this fires sometimes without a need)
                if (this.props.isLive === 'otherMedia') {
                    showError('Não é possível tocar essa música. Verifique a sua conexão de internet ou tente de novo em alguns momentos.');
                } else {
                    showError('Não é possível tocar o stream. Verifique a sua conexão de internet ou tente de novo em alguns momentos.');
                }

                // eslint-disable-next-line no-console
                console.error('Player Error: There is probably no internet connection');
            }

            this.props.onError();

            AudioEngine.pauseAndStopBuffering(0); // To reset the player (works also for non live streams)

            this.numErrors = 0;
        }
    };

    _onEnded = () => {
        // This event is fired when the server definately will not send more data. Not sure when this happens. Saw some 6500 events fired per day...
        // Now trying to reload the player if this event happens and the player should actually be playing

        if (this.props.isLive === 'otherMedia') {
            // set the player to the paused state
            this._pause();

            this.props.onEnded();
        } else if (this.props.shouldBePlaying) {
            // try to reload the player
            this.suppressNextPauseEvent = true;

            AudioEngine.load();

            AudioEngine.play();

            // log to GA
            this._logToGA('playerEnded', 'restarting', true);
        }
    }

    _onStalled = (e) => {
        // log to GA
        this._logToGA('playerStalled', false, true); // Couldn't get more information from the event, thus no extraLabel

        // eslint-disable-next-line no-console
        console.warn('player stalled', e);

        if (this.props.shouldBePlaying) {
            // if the player should be playing, show a message. (due to the unlock stuff this fires sometimes without a need. NOTE: Not sure if this is still the case. Copied from the _onError function)
            if (!this.stalledAlertId) {
                this.stalledAlertId = showError('Erro de reprodução. Tentando reconectar...');
            }
        }

        // @TODO maybe we have to retry loading here and after three times show the error message.
        // Retry loading only on iOS devices! On chrome this is not working. Chrome recovers from the stalled event alone.
        // Firefox emits the error event when stalled and thus will be cancelled after three retries.
        // @TODO check how other browsers are handling this and maybe adjust the audio engine to handle this...
    }

    _onPlaying = () => {
        this.numErrors = 0;

        clearTimeout(this.errorRetryHandle); // a retry succeeded (or is no longer needed), cancel any other pending retry

        if (this.stalledAlertId) {
            // dismiss the stalled alert if there is one
            dismissAlert(this.stalledAlertId);

            this.stalledAlertId = null;
        }

        this.debug('_onPlaying...');

        this.props.onPlaying(); // This will cancel the loading spinners
    }

    _onPause = () => {
        if (this.suppressNextPauseEvent) {
            // AudioEngine.load() (called by us, e.g. for a retry) just fired this as a side-effect, not an actual user/player pause
            this.suppressNextPauseEvent = false;

            return;
        }

        this.numErrors = 0;

        clearTimeout(this.errorRetryHandle); // do not let a stale retry resume playback after an explicit pause

        this.debug('_onPause...');

        this.props.onPause();
    }

    _onWaiting = () => {
        this.debug('_onWaiting...');

        this.props.onLoading();
    }

    _onContentPauseRequested = () => {
        this.debug('_onContentPauseRequested...');

        this.props.onLoading();
    }

    _onContentResumeRequested = () => {
        this.debug('_onContentResumeRequested...');

        // Note: This is only necessary on iOS devices, as here an 'pause' event is emitted
        // shortly before the contentResumeRequested event is emitted.
        if (this.props.playerStatus === 'paused') {
            this._play();
        }
    }

    _changeSource = (newSource, shouldBePlaying = this.props.shouldBePlaying) => {
        AudioEngine.setSrc(newSource);

        this.suppressNextPauseEvent = true;

        AudioEngine.load();

        if (shouldBePlaying && !this.props.playerStatus !== 'loading') {
            AudioEngine.play();
        }
    };

    _changeStream = (shouldBePlaying = this.props.shouldBePlaying) => {
        if (shouldBePlaying && !this.props.playerStatus !== 'loading') {
            this._play();
        }
    };

    _togglePlay = (shouldBePlaying) => {
        // this is a passive function. It is called when the store changes!

        // cancel any pending auto-retry from a previous error cycle, so it can't fire later and race this (now authoritative) play/pause request
        clearTimeout(this.errorRetryHandle);

        if (this.stalledAlertId) {
            // dismiss the stalled alert if there is one
            dismissAlert(this.stalledAlertId);

            this.stalledAlertId = null;
        }

        if (shouldBePlaying) {
            if (this.props.playerStatus === 'error') {
                // A previous error may have left the underlying <audio> element without a usable source loaded
                // (the internal recovery/reload logic doesn't always restore it). Force a full setSrc+load+play
                // instead of a bare play(), otherwise the player can get stuck showing "loading" forever.
                this._changeSource(this.props.currentSources);
            } else {
                AudioEngine.play();
            }

            this._gaHeartbeat();

            if (this.isListeningLoggingCounter === false && isProduction) {
                // start the ga logging if it wasn't started jet and only in production
                this._isListeningLogging();
            }

            // log to GA
            this._logToGA('playerStarted');
        } else {
            clearTimeout(this.heartBeatHandle);

            if (this.props.playerStatus === 'loading') {
                // Cancel the buffering if the status is loading (if the player got stuck somehow)
                AudioEngine.pauseAndStopBuffering(0);
            } else if (AudioEngine.isLiveStream()) {
                // Cancel the buffering after 3 seconds if it is a live stream (To avoid caching and playing an outdated stream)
                AudioEngine.pauseAndStopBuffering(3000);
            } else {
                AudioEngine.pause();
            }

            // log to GA
            this._logToGA('playerStopped');
        }
    };

    /* ACTIVE FUNCTIONS */

    _setVolume = (volume) => {
        AudioEngine.setVolume(volume / 100);
    };

    _play() {
        // use only this function to start the player
        if (this.props.isLive !== 'otherMedia') {
            this.props.playLive();
        } else {
            this.props.playMediaPlayer();
        }
    }

    _pause() {
        // use only this function to pause/stop the player
        this.props.pausePlayer();
    }

    _gaHeartbeat() {
        // This function sends an event to GA every x minutes to keep the session alive while the user is "only" listening to the stream...
        if (this.props.playerStatus === 'playing') {
            // only log if the player is actually playing //@TODO check if this is properly set when there is an error
            // this also serves to not log the first time the function is called
            // because at the same time there will be an playPressed event...

            // log to GA
            this._logToGA('isPlaying', false, true);
        }

        clearTimeout(this.heartBeatHandle); // just to be sure

        this.heartBeatHandle = setTimeout(() => { this._gaHeartbeat(); }, HEARTBEAT_LOGGING_INTERVAL);
    }

    _isListeningLogging() {
        // Log how much time the user is listening the stream
        // This is started only for the first play event!
        // NOTE: This function is not very precise! If the user stops the player, or switches the stream
        // and then starts the player again before the next logging event happened, it will be counted
        // as the complete time. (ex. user listened 15 minutes and stops the player for 10 minutes, if he starts the player again and listens 5 minutes, it will be logged as 30 minutes listened!)

        // If this is the first call, schedule the first log for to be after the first of the ISLISTENING_LOGGING_INTERVALS
        if (this.isListeningLoggingCounter === false) {
            this.isListeningLoggingCounter = 0;

            const delay = ISLISTENING_LOGGING_INTERVALS[this.isListeningLoggingCounter] * 60 * 1000;

            clearTimeout(this.isListeningLoggingHandle); // just o be sure

            this.isListeningLoggingHandle = setTimeout(() => this._isListeningLogging(), delay);

            return;
        }

        if (this.props.playerStatus === 'playing') {
            // If the player is playing do the log
            const minutesPassed = ISLISTENING_LOGGING_INTERVALS.slice(0, this.isListeningLoggingCounter + 1).reduce((a, b) => a + b, 0);

            // log to GA
            this._logToGA('isListening', `${minutesPassed} min`, true);

            // Log the events to facebook. (If the pixel was injected via GTM and initialized)
            if (typeof fbq !== 'undefined') {
                fbq('trackCustom', 'isListening', { time: `${minutesPassed} min` });
            }

            // Bing ads custom event
            window.uetq = window.uetq || [];

            window.uetq.push('event', 'isListening', { event_category: 'radio', event_label: 'ouvinte', event_value: minutesPassed });

            // Taboola custom event
            if (typeof _tfa !== 'undefined' && minutesPassed === 5) {
                _tfa.push({ notify: 'event', name: 'isListening5min', id: 1238647 });
            }

            // DDWB TABOOLA
            if (typeof _tfa !== 'undefined') {
                if (minutesPassed === 1) {
                    _tfa.push({ notify: 'event', name: 'view_content', id: 1630855 });
                } else if (minutesPassed === 5) {
                    _tfa.push({ notify: 'event', name: 'add_to_cart', id: 1630855 });
                } else if (minutesPassed === 15) {
                    _tfa.push({ notify: 'event', name: 'start_checkout', id: 1630855 });
                } else if (minutesPassed === 30) {
                    _tfa.push({ notify: 'event', name: 'add_payment_info', id: 1630855 });
                } else if (minutesPassed === 60) {
                    _tfa.push({ notify: 'event', name: 'make_purchase', id: 1630855 });
                }
            }

            // If there are still some logs left, start the timer again.
            if (this.isListeningLoggingCounter <= ISLISTENING_LOGGING_INTERVALS.length - 2) {
                this.isListeningLoggingCounter += 1;

                const delay = ISLISTENING_LOGGING_INTERVALS[this.isListeningLoggingCounter] * 60 * 1000;

                clearTimeout(this.isListeningLoggingHandle); // just to be sure

                this.isListeningLoggingHandle = setTimeout(() => this._isListeningLogging(), delay);
            }
        }
    }

    _logBuffer() {
        if (!AudioEngine.isInitialized()) return;

        if (this.props.playerStatus === 'playing' && !AudioEngine.adIsPlaying() && AudioEngine.getAudio().buffered.length > 0) {
            this.debug('buffered:', `${(AudioEngine.getAudio().buffered.end(0) - AudioEngine.getAudio().played.end(0)).toFixed(3)}s`);
        }

        setTimeout(() => { this._logBuffer(); }, 5000);
    }

    render() {
        const playerStatus = this.props.playerStatus;
        const title = playerStatus === 'loading' ? 'Carregando...' : playerStatus === 'playing' ? 'Pausar' : 'Tocar';

        return (
            <React.Fragment>
                <button
                    type="button"
                    className={`tw-rounded-full tw-w-[30px] tw-h-[30px] tw-flex tw-justify-center tw-items-center  tw-bg-white ${playerStatus === 'playing' ? 'pulseBtnForBar tw-rounded-full' : ''}`}
                    title={title}
                    onClick={playerStatus === 'loading' || playerStatus === 'playing' ? this._pause : this._play}
                >
                    {playerStatus === 'loading' ? (
                        <CircleNotch size={15} weight="light" color="#000000" className="tw-animate-spin" />
                    ) : playerStatus === 'playing' ? (
                        <Pause size={15} weight="fill" color="#000000" className="hover:tw-scale-110" />
                    ) : (
                        <Play size={15} weight="fill" color="#000000" className="hover:tw-scale-110" />
                    )}
                    <span className="visually-hidden visually-hidden-focusable">
                        {title}
                    </span>
                </button>
            </React.Fragment>
        );
    }
}

MediaPlayerComponent.propTypes = exact({
    playLive: PropTypes.func.isRequired,
    playMediaPlayer: PropTypes.func.isRequired,
    pausePlayer: PropTypes.func.isRequired,
    volume: PropTypes.number,
    shouldBePlaying: PropTypes.bool.isRequired,
    isLive: PropTypes.oneOfType([
        PropTypes.bool.isRequired,
        PropTypes.string.isRequired,
    ]),
    currentSources: PropTypes.oneOfType([
        PropTypes.array.isRequired,
        PropTypes.object.isRequired,
    ]),
    currentStreamId: PropTypes.string.isRequired,
    currentStream: PropTypes.shape({
        streamName: PropTypes.string.isRequired,
    }).isRequired,
    onError: PropTypes.func.isRequired,
    onPause: PropTypes.func.isRequired,
    onCanPlay: PropTypes.func.isRequired,
    onEnded: PropTypes.func.isRequired,
    onLoading: PropTypes.func.isRequired,
    onPlaying: PropTypes.func.isRequired,
    playerStatus: PropTypes.string.isRequired,
    trackList: PropTypes.arrayOf(
        PropTypes.shape({
            musicId: PropTypes.number.isRequired,
            musicTrack: PropTypes.string.isRequired, // hope that null will count as string...
            albumCover: PropTypes.string,
            iTunesLink: PropTypes.string,
            artistName: PropTypes.string.isRequired,
            artistSlug: PropTypes.string,
            musicName: PropTypes.string.isRequired,
            musicSlug: PropTypes.string,
            albumName: PropTypes.string,
        }),
    ).isRequired,
    currentIndex: PropTypes.oneOfType([
        PropTypes.bool.isRequired,
        PropTypes.number.isRequired,
    ]),
    playMediaFromSourceWithMeta: PropTypes.func.isRequired,
    setCurrentTrack: PropTypes.func.isRequired,
    // other possible media element events
    // onLoaded: PropTypes.func.isRequired,
    // onLoadedData: PropTypes.func.isRequired,
    // onPlay: PropTypes.func.isRequired,
    nowPlayingMusic: PropTypes.shape({
        artist: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.bool,
        ]),
        song: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.bool,
        ]),
    }),
    locked: PropTypes.bool.isRequired,
    jwt: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    userId: PropTypes.number,
    isPro: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    browserHash: PropTypes.string, // not required as it is not present on the server
    prerollAdTagUrls: PropTypes.shape({
        prerollAdTagUrlAdManager: PropTypes.string,
        prerollAdTagUrlTargetSpot: PropTypes.string,
    }),
});

export default MediaPlayerComponent;
